if(!customElements.get('custom-tabs-handler')) {
  customElements.define('custom-tabs-handler', class CustomTabsHandler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.onChangeHandler = this.onChange.bind(this);
      this.addEventListener('change', this.onChangeHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChangeHandler);
    }

    onChange(e) {
      window.dispatchEvent(new Event('scroll'));
      this.querySelectorAll('slider-component').forEach(slider => slider?.resetPages())
    }
  });
};